import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  LoopFieldsSet,
  useFormHandler,
  showToast,
  Backdrop,
  LogoLoader,
} from "../../../../../components";
import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import {
  addJobStart,
  updateJobDeatilsStart,
} from "../../../../../redux/slices/leads/leadsSlice";
import { useLoginUser } from "../../../../../hooks/useLoginUser";
import { getLocalRestrictionStart } from "../../../../../redux/slices/setting/settingsSlice";

const JobDetailsModal = ({
  data,
  companyId,
  onClose,
  isLoading,
  callFetchTodaysCompanies,
  onSave,
  enableLocationRestrictionCheck = false,
  onJobCountUpdate,
}) => {
  const [excelContent, setExcelContent] = useState("");
  const [comments, setComments] = useState("");
  const dispatch = useDispatch();
  const restrictions = useSelector(
    (state) => state?.settings?.generalSettings?.raSettings?.localRestrictions
  );
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const [jobLocationKey, setJobLocationKey] = useState(0);
  const initialFormData = {
    website: "",
    jobDescriptionLink: "",
    jobTitle: "",
    city: "",
    industry: "",
    postersDetails: [
      {
        id: uuidv4(),
        firstName: "",
        lastName: "",
        designation: "",
        email: "",
        phone: { code: "", number: "" },
        contactLocation: "",
      },
    ],
  };

  const { user } = useSelector((state) => state?.auth);
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, {
      // website: { type: "url", required: true },
      jobDescriptionLink: { type: "text", required: true },
      jobTitle: { type: "select", required: true },
      city: { type: "select", required: true },
      postersDetails: [
        {
          firstName: { type: "text", required: true, alphaOnly : true},
          lastName: { type: "text", required: true, alphaOnly: true},
          designation: { type: "text", required: true },
          email: { type: "email", required: true },
          // contactLocation: { type: "select", required: true },
        },
      ],
    });

  const isStateRestricted = (selectedLocation) => {
    if (!selectedLocation) return false;
    const locationValue = selectedLocation?.value || selectedLocation;
    if (typeof locationValue !== "string") return false;

    let stateName = "";
    if (locationValue.includes("-")) {
      const parts = locationValue.split("-");
      stateName = parts[parts.length - 1].trim();
    } else {
      stateName = locationValue.trim();
    }

    if (!stateName) return false;

    return restrictions.some(
      (r) => r.stateName?.toLowerCase() === stateName.toLowerCase()
    );
  };

  const handleSubmit = async () => {
    try {
      const isValid = validateAllFields();
      if (!isValid) return;
      const seenEmails = new Set();

      for (const p of formData.postersDetails) {
        const email = (p?.email || "").trim().toLowerCase();
        if (!email) continue;

        if (seenEmails.has(email)) {
          showToast(`Duplicate email found: ${email}`, "error");
          return;
        }
        seenEmails.add(email);
      }

      const jobLocation =
        typeof formData?.city === "object" && formData?.city?.value
          ? formData?.city?.value
          : formData?.city;
      // let [city, state] = jobLocation?.split("-");
      let city = "";
      let state = "";
      // console.log("jobLocation",jobLocation)
      // if (jobLocation) {
      if (typeof jobLocation === "string" && jobLocation.trim() !== "") {
        const parts = jobLocation
          .split("-")
          .map((p) => p.trim())
          .filter(Boolean);

        if (parts.length === 1) {
          state = parts[0];
        } else {
          city = parts[0] || "";
          state = parts[1] || "";
        }
      }

      const jobFieldsPayload = {
        website: formData?.website || "",
        description: formData?.jobDescriptionLink || "",
        title: formData?.jobTitle?.value ?? formData.jobTitle,
        location: { city, state } || {},
        industry: formData?.industry?.value ?? formData.industry,
        ...(comments && { comment: comments }),
      };
      const prospectsPayload = formData?.postersDetails.map((p) => {
        const rawLocation = p?.contactLocation;
        const location =
          typeof rawLocation === "object" && rawLocation?.value
            ? rawLocation.value
            : rawLocation ?? "";
        const safeLocation = typeof location === "string" ? location : "";

        const [city = "", state = ""] = safeLocation
          .split("-")
          .map((s) => s.trim());
        const originalProspect = data?.contactDetails?.find(
          (c) => c.uiid === p.uiid
        );

        // If email changed then reset uiid
        let uiidToSend = p.uiid || null;
        if (originalProspect && originalProspect?.email?.email !== (p.email || "").trim()) {
          uiidToSend = null;
        }
        if (originalProspect && originalProspect?.email?.email !== (p.email || "").trim()) {
          uiidToSend = null;
        }
        // return {
        //   // uiid: p.uiid || null,
        //   uiid: uiidToSend,
        //   firstName: p.firstName || "",
        //   lastName: p.lastName || "",
        //   designation: p.designation || "",
        //   // mobile: { code: p.phone?.code || "", number: p.phone?.number || "" },
        //   mobile: {
        //     code: p.phone?.code || "",
        //     number: p.phone?.number ? Number(p.phone.number) : null,
        //   },

        //   email: p.email || "",
        //   location: { city: city || "", state: state || "" },
        // };
        const prospect = {
          uiid: uiidToSend,
          firstName: p?.firstName || "",
          lastName: p?.lastName || "",
          designation: p?.designation || "",
          // email: p.email || "",
          email: {
            email: (p?.email || "").trim(),
          },
          location: { city: city || "", state: state || "" },
        };
        if (p?.phone?.number && String(p?.phone?.number).trim() !== "") {
          prospect.mobile = {
            code: p?.phone?.code || "",
            number: Number(p?.phone?.number),
          };
        }

        return prospect;
      });
      if (data?.id) {
        const action = {
          postActions: ["AddToProspect"],
          payload: [{ type: "SET", value: jobFieldsPayload }],
          additionalPayload: {
            Prospects: prospectsPayload,
            website: formData?.website,
            industry: formData?.industry?.value ?? formData.industry,
            comment: comments || "", // Allow clearing the comment
          },
        };
        const updatedCompany = {
          ...data,
          companyId: data?.companyId,
          website: formData?.website || "",
          jobDescription: formData?.jobDescriptionLink || "",
          comment: comments || "",
          jobTitle: formData?.jobTitle?.value ?? formData.jobTitle,
          jobLocation: formData?.city?.value || "",
          industry: formData?.industry?.value ?? formData.industry,
          Prospects: prospectsPayload.map((p) => ({
            firstName: p?.firstName,
            lastName: p?.lastName,
            email: (p?.email?.email || "").trim(),
            phone: p?.mobile?.number
              ? `${p?.mobile?.code} ${p?.mobile?.number}`
              : "",
            designation: p?.designation,
            location: p?.location,
            uiid: p?.uiid || null,
          })),
        };
        dispatch(
          updateJobDeatilsStart({
            uiid: data.id,
            payload: action,
            onSuccess: () => {
              onClose();
              if (onSave) onSave(updatedCompany);
              callFetchTodaysCompanies();
              onJobCountUpdate?.();
            },
          })
        );
      } else {
        // Add mode
        if (!user?.data?.uiid) throw new Error("User ID is missing");

        // const jobLoc = (formData.city?.value || "").trim().toLowerCase();

        // const isLocationMatch = formData.postersDetails.every((poster) => {
        //   if (!poster.contactLocation) return false; // reject null
        //   const contactLoc = (
        //     poster.contactLocation.value ||
        //     poster.contactLocation ||
        //     ""
        //   )
        //     .trim()
        //     .toLowerCase();
        //   return contactLoc === jobLoc;
        // });

        // if (!isLocationMatch) {
        //   showToast(
        //     "Job location must match all poster contact locations",
        //     "error"
        //   );
        //   return; // STOP adding the job
        // }

        if (!user?.data?.uiid) throw new Error("User ID is missing");
        const payload = {
          coll: "Job",
          postActions: ["AddToProspect"],
          payload: {
            ...jobFieldsPayload,
            addedBy: loginUserUiid,
            companyId,
            Prospects: prospectsPayload,
          },
        };

        dispatch(
          addJobStart({
            payload,
            onSuccess: () => {
              onClose();
              callFetchTodaysCompanies();
              onJobCountUpdate?.();
            },
          })
        );
      }
    } catch (err) {
      console.log("err", err);
      showToast(err.message || "Failed to save job", "error");
    }
  };

  const addPostersDetails = () => {
    const newPoster = {
      id: uuidv4(),
      firstName: "",
      lastName: "",
      designation: "",
      email: "",
      phone: { code: "", number: "" },
      contactLocation: "",
    };
    setFormData({
      ...formData,
      postersDetails: [...formData.postersDetails, newPoster],
    });
  };

  const removePosterDetails = (posterId) => {
    if (formData.postersDetails.length > 1) {
      setFormData({
        ...formData,
        postersDetails: formData.postersDetails.filter(
          (poster) => poster.id !== posterId
        ),
      });
    }
  };

  useEffect(() => {
    if (data) {
      let cityStateValue = { city: "", state: "" };
      // if (data.jobLocation) {
      //   const parts = data.jobLocation.split(",").map((p) => p.trim());
      //   cityStateValue = { city: parts[0] || "", state: parts[1] || "" };
      // }
      if (data.jobLocation) {
        const cleanedLocation = data.jobLocation.trim();
        const withoutCountry = cleanedLocation
          .replace(/\b(US|U\.S\.A\.?|United States|USA)\b/gi, "")
          .replace(/\s*,\s*$/, "")
          .trim();
        if (withoutCountry.includes(" - ")) {
          cityStateValue = withoutCountry;
        } else {
          const parts = withoutCountry
            .split(",")
            .map((p) => p.trim())
            .filter((p) => p && p !== "-");

          cityStateValue = parts.join(" - ");
        }
      }
      // console.log("data.contactDetails",data.contactDetails)
      setFormData({
        website: data.website || "",
        jobDescriptionLink: data.jobDescription || "",
        jobTitle: { value: data.jobTitle, label: data.jobTitle },
        city: {
          // value: `${cityStateValue.city} - ${cityStateValue.state}`,
          // label: data.jobLocation,
          value: cityStateValue,
        },
        industry: { value: data.industry, label: data.industry },
        // postersDetails: data.contactDetails?.map((contact) => {
        //   const phoneParts = contact.phone?.split(" ") || ["", ""];
        //   // console.log("phoneParts", phoneParts);
        //   // const code = contact.phone?.code || "";
        //   // const number = contact.phone?.number
        //   //   ? String(contact.phone.number)
        //   //   : "";
        //   return {
        //     id: uuidv4(),
        //     firstName: contact.name?.split(" ")[0] || "",
        //     lastName: contact.name?.split(" ")[1] || "",
        //     designation: contact.designation || "",
        //     email: contact.email || "",
        //     phone: { code: phoneParts[0], number: phoneParts[1] },
        //     // phone: { code: phoneParts[0], number: String(phoneParts[1] || "") },
        //     // phone: { code, number },

        //     // contactLocation: {
        //     //   value: `${contact.location.city}-${contact.location.state}`,
        //     //   label: `${contact.location.city}-${contact.location.state}`,
        //     // },
        //     contactLocation: (() => {
        //       const city = contact.location?.city?.trim();
        //       const state = contact.location?.state?.trim();
        //       const locationParts = [city, state].filter(Boolean);

        //       const labelValue = locationParts.join("-");
        //       return {
        //         value: labelValue,
        //         label: labelValue,
        //       };
        //     })(),
        //     uiid: contact.uiid || null,
        //   };
        // }) || [
        //   {
        //     id: uuidv4(),
        //     firstName: "",
        //     lastName: "",
        //     designation: "",
        //     email: "",
        //     phone: { code: "", number: "" },
        //     contactLocation: { value: "", label: "" },
        //   },
        // ],
        postersDetails: data.contactDetails?.map((contact) => {
          // Handle phone safely
          // let phone = { code: "", number: "" };

          // if (contact.phone && typeof contact.phone === "string" && contact.phone.trim() !== "") {
          //   const phoneParts = contact.phone.split(" ").filter(Boolean);
          //   phone = {
          //     code: phoneParts[0] || "",
          //     number: phoneParts[1] || "",
          //   };
          // }
          let phone = { code: "", number: "" };

          if (contact.phone) {
            if (
              typeof contact.phone === "string" &&
              contact.phone.trim() !== ""
            ) {
              const phoneParts = contact.phone.split(" ").filter(Boolean);
              phone = {
                code: phoneParts[0] || "",
                number: phoneParts[1] || "",
              };
            } else if (typeof contact.phone === "object") {
              phone = {
                code: contact.phone.code || "",
                number: contact.phone.number || "",
              };
            }
          }

          if (!phone.code) phone.code = "";
          if (!phone.number) phone.number = "";

          return {
            id: uuidv4(),
            firstName: contact.name?.split(" ")[0] || "",
            lastName: contact.name?.split(" ")[1] || "",
            designation: contact.designation || "",
            email: contact.email?.email || "",
            phone, // only shows if truthy
            contactLocation: (() => {
              const city = contact.location?.city?.trim();
              const state = contact.location?.state?.trim();
              const locationParts = [city, state].filter(Boolean);
              const labelValue = locationParts.join(" - ");
              return {
                value: labelValue,
                label: labelValue,
              };
            })(),
            uiid: contact.uiid || null,
          };
        }) || [
          {
            id: uuidv4(),
            firstName: "",
            lastName: "",
            designation: "",
            email: "",
            phone: { code: "", number: "" },
            contactLocation: { value: "", label: "" },
          },
        ],
      });
      setComments(data?.comment || "");
    }
  }, [data]);

  const handlePaste = (event) => {
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedText = clipboardData.getData("text");
    const rows = pastedText.split("\n").filter((row) => row.trim() !== "");

    const newData = rows
      .map((row) => {
        const [
          firstName = "",
          lastName = "",
          designation = "",
          email = "",
          phone = "",
          city = "",
          state = "",
        ] = row.split("\t");
        // Remove carriage return (\r) characters from phone number
        const cleanedPhoneNumber = phone.replace(/\D/g, "");
        return {
          id: uuidv4(),
          firstName,
          lastName,
          designation,
          email,
          phone: { code: "+1", number: cleanedPhoneNumber },
          contactLocation: {
            label: [city, state]
              .map((s) => s?.trim())
              .filter(Boolean)
              .join(" - "),
            value: [city, state]
              .map((s) => s?.trim())
              .filter(Boolean)
              .join(" - "),
          },
        };
      })
      .filter(
        (contact) =>
          contact.firstName.trim() ||
          contact.lastName.trim() ||
          contact.designation.trim() ||
          contact.email.trim() ||
          contact.phone.number.trim() ||
          contact.contactLocation.value.trim() ||
          contact.contactLocation.label.trim()
      );

    setFormData((prevData) => {
      // Filter out empty previous rows
      const nonEmptyPrevData = prevData.postersDetails.filter(
        (contact) =>
          (contact.firstName && contact.firstName.trim()) ||
          (contact.lastName && contact.lastName.trim()) ||
          (contact.designation && contact.designation.trim()) ||
          (contact.emailId && contact.email.trim()) ||
          (contact.phone && contact.phone?.number.trim()) ||
          (contact.contactCity && contact.contactLocation?.value.trim())
      );

      const availableSlots = 5 - nonEmptyPrevData.length;
      const dataToAdd = newData.slice(0, availableSlots);

      if (newData.length > availableSlots) {
        showToast("No more than 5 contacts", "error", 5000);
      }

      return {
        ...formData,
        postersDetails: [...nonEmptyPrevData, ...dataToAdd],
      };
    });
  };

  useEffect(() => {
    if (!restrictions || restrictions.length === 0) {
      const action = {
        coll: "LocationRestriction",
        lim: 200,
        pg: 1,
        ret: "uiid stateName stateCode addedOn",
      };
      dispatch(getLocalRestrictionStart(action));
    }
  }, [restrictions?.length, dispatch]);

  return (
    <div className="p-3 min-h-[600px] flex flex-col">
      <h5>Job Details</h5>
      <div className="flex flex-col gap-4 my-5 xl:mr-40">
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          <FormFieldSet
            title="Website"
            placeholder="Website"
            value={formData.website}
            onChange={(value) => handleChange("website", value)}
            error={errors.website}
          />
          <FormFieldSet
            title="Job Description"
            placeholder="Enter Job Description Link"
            value={formData.jobDescriptionLink}
            onChange={(value) => handleChange("jobDescriptionLink", value)}
            error={errors.jobDescriptionLink}
          />
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          <FormFieldSet
            type="atsJobTitle"
            title="Job Title"
            placeholder="Select Job Title"
            value={formData.jobTitle}
            onChange={(value) => handleChange("jobTitle", value)}
            error={errors.jobTitle}
            showButton
            showSearch
          />
          <FormFieldSet
            key={jobLocationKey}
            // type="citiesState"
            type="atscitiesState"
            title="Job Location"
            placeholder="Select Job Location"
            value={formData.city}
            // onChange={(value) => handleChange("city", value)}
            onChange={(value) => {
              if (enableLocationRestrictionCheck && isStateRestricted(value)) {
                showToast(
                  "The selected state has been restricted. Please choose another location.",
                  "error"
                );
                setFormData((prev) => ({ ...prev, city: "" }));
                setJobLocationKey((prev) => prev + 1);
                return;
              }
              handleChange("city", value);
            }}
            showSearch
            parentValue={{ country: "6807640e7ecb9f7d31314b7e" }}
          />
          <FormFieldSet
            type="industry"
            title="Select Industry"
            placeholder="Select Industry"
            options={[]}
            showButton
            showSearch
            value={formData.industry || ""}
            onChange={(value) => handleChange("industry", value)}
          />
        </div>
        <FormFieldSet
          title="Paste Excel Content Here"
          placeholder="Paste Excel Content Here..."
          value={excelContent}
          onChange={(value) => setExcelContent(value)}
          onPaste={(e) => handlePaste(e)}
        />

        <FormFieldSet
          title="Comments(optional)"
          placeholder="Write your comments here"
          value={comments}
          onChange={(value) => setComments(value)}
        />
      </div>

      <LoopFieldsSet
        title="Job Posters Details"
        titleConfig={{ tag: "h6" }}
        data={formData.postersDetails}
        onAdd={addPostersDetails}
        onRemove={removePosterDetails}
        gridCols="grid-cols-[repeat(6,1fr)_30px]"
        maxItems={5}
        addButtonTitle="Add More Contacts"
        renderFields={(poster, index) => (
          <>
            <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
              <FormFieldSet
                type="text"
                title="First Name"
                placeholder="Enter First Name"
                value={poster.firstName || ""}
                onChange={(value) =>
                  handleChange(`postersDetails[${index}].firstName`, value)
                }
                error={errors.postersDetails?.[index]?.firstName}
              />
            </div>
           <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
              <FormFieldSet
                type="text"
                title="Last Name"
                placeholder="Enter Last Name"
                value={poster.lastName || ""}
                onChange={(value) =>
                  handleChange(`postersDetails[${index}].lastName`, value)
                }
                error={errors.postersDetails?.[index]?.lastName}
              />
            </div>
           <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
              <FormFieldSet
                type="text"
                title="Designation"
                placeholder="Enter Designation"
                value={poster.designation || ""}
                onChange={(value) =>
                  handleChange(`postersDetails[${index}].designation`, value)
                }
                error={errors.postersDetails?.[index]?.designation}
              />
            </div>
            <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
              <FormFieldSet
                type="text"
                title="Email Id"
                placeholder="Enter Email Id"
                value={poster.email || ""}
                onChange={(value) =>
                  handleChange(`postersDetails[${index}].email`, value)
                }
                error={errors.postersDetails?.[index]?.email}
              />
            </div>
            {/* <FormFieldSet
              type="phoneNew"
              title="Phone"
              placeholder="Enter Phone"
              values={[poster.phone]}
              onChange={(value) =>
                handleChange(`postersDetails[${index}].phone`, value[0])
              }
              error={errors.postersDetails?.[index]?.phone}
            /> */}
            <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
              <FormFieldSet
                type="phone"
                title="Phone"
                placeholder="Enter Mobile Number"
                value={poster.phone?.number || ""}
                code={poster.phone?.code || ""}
                onChange={(fullValue, details) =>
                  handleChange(`postersDetails[${index}].phone`, {
                    code: details.countryCode,
                    number: details.number,
                  })
                }
                error={errors.postersDetails?.[index]?.phone}
              />
            </div>
            <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
              <FormFieldSet
                type="atscitiesState"
                title="Contact Location"
                placeholder="Select Contact Location"
                value={poster.contactLocation}
                onChange={(value) =>
                  handleChange(
                    `postersDetails[${index}].contactLocation`,
                    value
                  )
                }
                showSearch
                parentValue={{ country: "6807640e7ecb9f7d31314b7e" }}
                error={errors.postersDetails?.[index]?.contactLocation}
              />
            </div>
          </>
        )}
      />

      <div className="flex justify-end gap-5 mt-auto mb-5">
        <Button
          title="Cancel"
          onClick={onClose}
          variant="outlined"
          color="black"
        />
        <Button title="Submit" onClick={handleSubmit} />
      </div>

      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default JobDetailsModal;
